/** Closed set of structured underwriting rule types. */
export const UNDERWRITING_RULE_CODES = [
  'MIN_RESERVES_MONTHS',
  'MIN_LOAN_AMOUNT',
] as const

export type UnderwritingRuleCode = (typeof UNDERWRITING_RULE_CODES)[number]

const RULE_CODE_SET: ReadonlySet<string> = new Set(UNDERWRITING_RULE_CODES)

export function isUnderwritingRuleCode(
  value: string,
): value is UnderwritingRuleCode {
  return RULE_CODE_SET.has(value)
}

export const UNDERWRITING_RULE_CODE_LABELS: Record<
  UnderwritingRuleCode,
  string
> = {
  MIN_RESERVES_MONTHS: 'Minimum months of reserves',
  MIN_LOAN_AMOUNT: 'Minimum loan amount',
}
